import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import { LoaderProvider } from './context/LoaderContext';
import { ToastProvider } from "./context/ToastContext";
import GlobalLoader from './components/GlobalLoader';
import { GoogleOAuthProvider } from '@react-oauth/google';

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <ToastProvider>
        <LoaderProvider>
          <GlobalLoader />
          <App />
        </LoaderProvider>
      </ToastProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
